import React from 'react';
import styled from 'styled-components';
import Icon from '../../icon';

export default function ExpanderDefinition(content) {
	if (!(this instanceof ExpanderDefinition)) {
		return new ExpanderDefinition(content);
	}

	let width;
	let maxWidth;
	let header;
	let expandedPropertyPath = '__expanded';
	let expansionListener;

	let visibleCallback;
	let visible;

	if (typeof content === 'function') {
		content._parentDefinition = this;
	}

	this.setVisible = function(value) {
		if (typeof value === 'function') {
			visibleCallback = value;
			visible = true;
		} else {
			visibleCallback = null;
			visible = value;
		}
		return this;
	};

	const isVisible = function(ctx) {
		if (visibleCallback) {
			return visibleCallback(ctx);
		} else {
			return visible;
		}
	};

	this.onExpandedChanged = function(value) {
		expansionListener = value;
		return this;
	};

	this.setWidth = function(value) {
		width = value;
		return this;
	};

	this.setHeader = function(value) {
		header = value;
		return this;
	};

	this.setExpandedPropertyPath = function(value) {
		expandedPropertyPath = value;
		return this;
	}

	this.setMaxWidth = function(value) {
		maxWidth = value;
		return this;
	};

	this.getContent = function() {
		return content;
	};

	this.validateAll = function(ctx, errors) {
		content.validateAll(ctx, errors);
	}

	this.validateOnChange = function(ctx, errors, itemName) {
		if (this._parentDefinition && this._parentDefinition.validateOnChange) {
			this._parentDefinition.validateOnChange(ctx, errors, itemName);
		}
	};


	this.render = function(ctx, key = 0) {
		if (!isVisible(ctx)) {
			return null;
		}
		const expanded = ctx.getProperty(expandedPropertyPath);
		return (
			<Expander
				key={key}
				width={width}
				maxWidth={maxWidth}
				expanded={expanded}
				onToggleExpanded={() => {
					ctx.setProperty(expandedPropertyPath, !expanded);
					if (expansionListener) {
						expansionListener(ctx, !expanded);
					}
				}}
				header={header}
			>
				{content.render(ctx)}
			</Expander>
		)
	};
}

const ExpanderWrapper = styled.div`
	width: ${props => props.width};
	max-width: ${props => props.maxWidth};
`;

const Header = styled.div`
	padding: 4px;
	cursor: pointer;
	font-weight: 700;
	&:hover {
		text-decoration: underline;
	}
	.icon {
		position: relative;
		top: -1px;
		margin-right: 4px;
	}
`;

const Content = styled.div`
`;

class Expander extends React.Component {
	render() {
		return (
			<ExpanderWrapper
				width={this.props.width}
				maxWidth={this.props.maxWidth}
			>
				<Header
					onMouseDown={e => {
						e.target.focus();
						e.preventDefault();
						this.props.onToggleExpanded();
					}}
				>
					<Icon
						name={this.props.expanded ? 'expanded' : 'collapsed'}
					/>
					<span className="text">{this.props.header}</span>
				</Header>
				{
					this.props.expanded && (
						<Content>
							{this.props.children}
						</Content>
					)
				}
			</ExpanderWrapper>
		);
	}
}
